// permissionsMapping.js

export const PERMISSION_MAPPING = {
  // Permisos de Administrador
  1: { // OC - Administrador
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "OC",
    path: "/oc"
  },
  5: { // Compradores - Administrador
    menuItem: "SEGUIMIENTO OC - ATC", 
    subMenuItem: "Compradores",
    path: "/compradores"
  },
  7: { // Evaluaciones - Administrador
    menuItem: "PROVEEDORES",
    subMenuItem: "Evaluar",
    path: "/evaluacion"
  },
  8: { // Beneficios - Administrador
    menuItem: "PROVEEDORES",
    subMenuItem: "Beneficios",
    path: "/beneficios"
  },
  10: { // Manual de información - Administrador
    menuItem: "MANUALES DE INFORMACIÓN",
    path: "/manuales-de-informacion"
  },
  15: { // Usuarios - Administrador
    menuItem: "GESTIÓN DE USUARIOS",
    subMenu: [
      { text: "Registro de usuarios", path: "/registro-usuario" },
      { text: "Usuarios administradores", path: "/lista-administrador" },  
      { text: "Usuarios proveedores", path: "/lista-proveedor" },
      { text: "Usuarios compradores", path: "/lista-comprador" },
      { text: "Usuarios invitados", path: "/lista-invitado" },
    ]
  },
  16: { // Dashboard - Administrador
    menuItem: "INICIO",
    path: "/inicio"
  },
  20: { // Gestión de Accesos - Administrador
    menuItem: "CONFIGURACIÓN",
    path: "/administrar-accesos"
  },
  25: { // OC Histórico - Administrador
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "OC Histórico",
    path: "/oc-historico"
  },
  27: { // Criterios de Evaluación - Administrador
    menuItem: "PROVEEDORES",
    subMenuItem: "Criterios de evaluación",
    path: "/criterios-de-evaluacion"
  },
  31: { // Historial - Administrador
    menuItem: "ANUNCIOS",
    subMenu: [
      { text: "Publicar", path: "/publicar-anuncio" },
      { text: "Historial", path: "/historial-anuncios" }
    ]
  },
  32: { // Conócenos - Administrador
    menuItem: "CONÓCENOS",
    path: "/conocenos"
  },
  34: { // Req. inicio temporada - Administrador
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Requisitos de inicio de temp.",
    path: "/requisitos-de-inicio-de-temporada"
  },
  36: { // Documentos - Administrador
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Documentos",
    path: "/documentos"
  },
  37: { // Temporadas - Administrador
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Temporadas",
    path: "/temporadas"
  },

  38: { // Encuestas - Administrador
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Encuestas",
    path: "/encuestas"
  },
  39: { // Histórico de encuestas - Administrador
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Histórico de encuestas",
    path: "/historico-de-encuestas"
  },


  // Permisos de Proveedor
  9: { // Ranking - Proveedor
    menuItem: "PROVEEDORES",
    subMenuItem: "Ranking",
    path: "/ranking"
  },
  17: { // Centria - Proveedor
    menuItem: "CENTRIA",
    href: "https://proveedores.centria.net/",
    target: "_blank"
  },
  18: { // Aulavirtual - Proveedor
    menuItem: "AULAVIRTUAL", 
    href: "https://tasaproveedores.daktico.com/",
    target: "_blank"
  },
  23: { // Dashboard - Proveedor
    menuItem: "INICIO",
    path: "/inicio"
  },
  24: { // OC - Proveedor
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "Mis OC",
    path: "/mis-oc"
  },
  26: { // Compradores - Proveedor
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "Compradores ",
    path: "/compradores"
  },
  28: { // Evaluaciones - Proveedor
    menuItem: "PROVEEDORES",
    subMenuItem: "Mi evaluación",
    path: "/mi-evaluacion"
  },
  29: { // Beneficios - Proveedor
    menuItem: "PROVEEDORES",
    subMenuItem: "Mis beneficios",
    path: "/mis-beneficios"
  },
  30: { // Manual de información - Proveedor
    menuItem: "MANUALES DE INFORMACIÓN",
    path: "/manuales-de-informacion"
  },
  33: { // Conócenos - Proveedor
    menuItem: "CONÓCENOS",
    path: "/conocenos"
  },
  35: { // Req. inicio de temp - Proveedor
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Requisitos de inicio de temp. ",
    path: "/requisitos-de-inicio-de-temporada"
  },
  40: { // Encuestas - Proveedor
    menuItem: "DOCUMENTACIÓN",
    subMenuItem: "Mis encuestas",
    path: "/mis-encuestas"
  },

  42: { // ATC - Proveedor
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "Mis ATC",
    path: "/mis-atc"
  },
  41: { // ATC - Administrador
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "ATC",
    path: "/atc"
  },
  43: { // Facturacion - Administrador
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "Facturación",
    path: "/facturacion"
  },
  44: { // Facturacion - Proveedor
    menuItem: "SEGUIMIENTO OC - ATC",
    subMenuItem: "Mi facturación",
    path: "/mi-facturacion"
  },
  45: { // Gestión de citas - Administrador
    menuItem: "RECURSOS",
    subMenuItem: "Gestión de citas",
    path: "/gestion-de-citas"
  },
  46: { // Agendar - Proveedor
    menuItem: "RECURSOS",
    subMenuItem: "Agendar cita",
    path: "/agendar-cita"
  },
  47: { // Gestión de horarios - Administrador
    menuItem: "RECURSOS",
    subMenuItem: "Gestión de horarios",
    path: "/gestion-de-horarios"
  },

};

// Función para verificar si un usuario tiene un permiso específico
export const hasPermission = (permissions, permissionId) => {
  return permissions.some(perm => perm.id === permissionId);
};

// Función para filtrar elementos del menú basado en permisos
export const filterMenuByPermissions = (menuItems, permissions, roleId, user) => {
  return menuItems.filter(item => {
    // Buscar si el elemento del menú está en el mapeo de permisos
    const permissionEntries = Object.entries(PERMISSION_MAPPING).filter(([id, config]) => 
      config.menuItem === item.text
    );
    
    if (permissionEntries.length > 0) {
      // Verificar si el usuario tiene AL MENOS UNO de los permisos asociados
      return permissionEntries.some(([id, config]) => 
        hasPermission(permissions, parseInt(id))
      );
    }
    
    // Si no está en el mapeo, permitirlo (para elementos que no requieren permiso específico)
    return true;
  }).map(item => {
    // Filtrar submenús si existen
    if (item.subMenu) {
      const filteredSubMenu = item.subMenu.filter(subItem => {
        const subPermissionEntry = Object.entries(PERMISSION_MAPPING).find(([id, config]) => 
          config.menuItem === item.text && config.subMenuItem === subItem.text
        );
        
        if (subPermissionEntry) {
          const permissionId = parseInt(subPermissionEntry[0]);
          return hasPermission(permissions, permissionId);
        }
        
        return true;
      });
      
      // Reemplazar paths dinámicos
      const processedSubMenu = filteredSubMenu.map(subItem => {
        if (subItem.path && subItem.path.includes(':supplierId') && user?.supplierId) {
          return {
            ...subItem,
            path: subItem.path.replace(':supplierId', user.supplierId)
          };
        }
        return subItem;
      });
      
      return {
        ...item,
        subMenu: processedSubMenu.length > 0 ? processedSubMenu : null
      };
    }
    
    return item;
  }).filter(item => {
    // Eliminar elementos de menú que no tienen submenús (si los deberían tener)
    if (item.subMenu !== undefined && item.subMenu === null) {
      return false;
    }
    return true;
  });
};